module.exports = __webpack_public_path__ + "img/shop.6d2d9ef0.png";